import { Component, OnInit, Input } from '@angular/core';
import { TbAuthService } from '@tb/auth';
import { CmsService } from 'src/app/core/services/cms.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { UserServices } from 'src/app/core/services/user.services';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { LoginService } from 'src/app/core/services/login.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { ModelService } from 'src/app/core/services/model.service';
import { Account } from '../../model/account';

@Component({
    selector: 'tb-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() parentPage = '';
    @Input() quotationOrIndustryDescri = '';
    @Input() specificTitle ='';
    @Input() specificSubTitle ='';
    @Input() specificSubSubTitle =''
    @Input() isDashboardHeader = false;
    @Input() isCircleHeader = false;
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    //@Input() isQuotation:boolean;
    public title: string;
    public subTitle: string;
    public subSubTitle: string;
    public youAreModifing: string;
    public youAreModifingaquotation: string;
    public youAreModifinganIndustry: string;
    public FullName = '';

    isLogged: boolean = false;
    public cmsObj: CmsObject[];
    language: string;
    constructor(private cmsService: CmsService, private modelService: ModelService, private workFlow: WorkFlowService,public navigateService: NavigateService,private loginService: LoginService) {}

    async ngOnInit() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.isLogged = this.authorizationProperties ? true : false;
        if (this.isLogged) {
            await this.getInfoAccount();
          }
        if (this.parentPage != '')
            await this.getCmsObj();
        if (this.specificTitle != '') 
        {
            this.title = this.specificTitle;
        }
        if (this.specificSubTitle != '') 
            this.subTitle = this.specificSubTitle;
        if (this.specificSubSubTitle != '') 
            this.subSubTitle = this.specificSubSubTitle;
       
    }

    async getInfoAccount() {
        let opRes = await this.loginService.getAccountToPromiseBy(this.authorizationProperties.accountName);
            const account: Account = opRes["Content"];
            this.FullName = account.FullName;
      }

    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, this.parentPage.toLowerCase());
        var title = this.cmsObj.find((x) => x.ContentName == this.parentPage + '.title');
        this.title = title != undefined ? title.ContentTranslation : '';

        var subTitle = this.cmsObj.find((x) => x.ContentName == this.parentPage + '.subtitle');
        this.subTitle = subTitle != undefined ? subTitle.ContentTranslation : '';

        var subSubTitle = this.cmsObj.find((x) => x.ContentName == this.parentPage + '.subSubtitle');
        this.subSubTitle = subSubTitle != undefined ? subSubTitle.ContentTranslation : '';

        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'header');
        this.youAreModifingaquotation = this.cmsObj.find((x) => x.ContentName == 'header.youAreModifingaquotation').ContentTranslation;
        this.youAreModifinganIndustry = this.cmsObj.find((x) => x.ContentName == 'header.youAreModifinganIndustry').ContentTranslation;
    }
}
